import gsap from 'gsap';
import RytmWebflow from 'rytm-webflow'


class HeaderPartView extends RytmWebflow.WebflowView {

  constructor(id) {
    super(id)
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container);
    const delay = container ? (container.dataset.animationDelay || 0) : 0;
    gsap.killTweensOf(container);
    gsap.set(container, {y: -90});
    gsap.to(container, {y: 0, duration: .8, delay, ease: 'power3.out'});
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container);
    gsap.killTweensOf(container);
    gsap.to(container, {y: -90, duration: .4, delay: .4, ease: 'power3.in'});
  }

}

export default HeaderPartView